import { render, staticRenderFns } from "./adminProduct.vue?vue&type=template&id=42eac27a&scoped=true"
import script from "./adminProduct.vue?vue&type=script&lang=js"
export * from "./adminProduct.vue?vue&type=script&lang=js"
import style0 from "./adminProduct.vue?vue&type=style&index=0&id=42eac27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42eac27a",
  null
  
)

export default component.exports